const API_BASE_URL =
  process.env.REACT_APP_REMISIONES_API_URL ||
  "https://0n4eu7r5g0.execute-api.us-east-1.amazonaws.com/dev";

function getToken() {
  const token =
    localStorage.getItem("idToken") ||
    localStorage.getItem("accessToken");

  if (!token) {
    throw new Error("No hay una sesión activa. Cierra sesión e inicia nuevamente.");
  }

  try {
    const payload = JSON.parse(
      atob(
        token
          .split(".")[1]
          .replace(/-/g, "+")
          .replace(/_/g, "/")
      )
    );

    if (payload?.exp && payload.exp * 1000 <= Date.now()) {
      throw new Error("La sesión expiró. Cierra sesión e inicia nuevamente.");
    }
  } catch (error) {
    if (error?.message?.includes("sesión")) throw error;
  }

  return token;
}

async function request(path, options = {}) {
  const token = getToken();

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });

  const raw = await response.text();

  let data = {};
  try {
    data = raw ? JSON.parse(raw) : {};
  } catch {
    data = { error: raw || "Respuesta inválida del servidor." };
  }

  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      throw new Error(
        data?.message ||
          data?.error ||
          "La sesión expiró o no tiene autorización."
      );
    }

    throw new Error(
      data?.error ||
        data?.message ||
        `Error HTTP ${response.status}`
    );
  }

  return data;
}

export function listRemisiones(filters = {}) {
  const query = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value) query.set(key, value);
  });

  const suffix = query.toString() ? `?${query.toString()}` : "";

  return request(`/remisiones${suffix}`, {
    method: "GET",
  });
}

export function createRemision(payload) {
  return request("/remisiones", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateRemision(id, payload) {
  return request(`/remisiones/${encodeURIComponent(id)}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export function finalizeRemision(id) {
  return request(`/remisiones/${encodeURIComponent(id)}/finalizar`, {
    method: "POST",
    body: "{}",
  });
}

export function updateRemisionGuide(id, payload) {
  return request(`/remisiones/${encodeURIComponent(id)}/guia`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export function markRemisionDelivered(id, payload = {}) {
  return request(`/remisiones/${encodeURIComponent(id)}/entregada`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function getRemisionPdf(id) {
  return request(`/remisiones/${encodeURIComponent(id)}/pdf`, {
    method: "GET",
  });
}
